import queryKeys from "@/constants/queryKeys";
import { getBoardPermission } from "@/services/monday";
import { useQuery } from "react-query";

export const useGetBoardPermissionQuery = (boardId?: number, userId?: number) => {
  return useQuery<boolean>(
    [queryKeys.MONDAY_GET_BOARD_PERMISSION, boardId, userId],
    () => getBoardPermission(boardId ?? 0, userId?.toString() ?? ''),
    {
      enabled: !!boardId && !!userId,
      refetchOnWindowFocus: false,
    },
  );
};
